import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42e376a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "set-main-space content-box" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " 正在设置主空间,设置成功后,将关闭弹窗,并且进入空间页面 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spaceData, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "space-item",
        onClick: ($event: any) => (_ctx.checkMainSpace(item)),
        key: 'space' + index
      }, [
        _createVNode(_component_van_swipe_cell, null, {
          right: _withCtx(() => [
            _createVNode(_component_van_button, {
              square: "",
              type: "danger",
              onClick: ($event: any) => (_ctx.delWorkSpace(item)),
              text: "删除"
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              border: false,
              title: item.spaceName
            }, null, 8, ["title"])
          ]),
          _: 2
        }, 1024)
      ], 8, _hoisted_2))
    }), 128)),
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}